/**
 * 本地开关缓存 配置
 * @author lianghua.fu
 * @date 2022-07-21 14:37:11
 */
import storage from './storage';
import assign from 'lodash/assign';

const cacheKey = 'MM_SWITCH_V2';

const defaultStatus = {
  gift: true, // 礼物特效
  enterAnimation: true, // 进场动效
  chatAnimation: true, // 聊天气泡，装扮效果
  location: true,
};

let currentCache = null;

const getCache = () => {
  if (!currentCache) {
    currentCache = assign(
      currentCache || {},
      defaultStatus,
      storage.getItem(cacheKey),
    );
  }
  return currentCache;
};

const saveCache = (value) => {
  currentCache = value;
  storage.setItem(cacheKey, value);
};

const getSwitch = (key) => {
  getCache();
  return currentCache && currentCache![key];
};

export default {
  getCache,
  saveCache,
  getSwitch,
};
